<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="id"
      :itemNames="['name_1','name_2','name_3','name_4']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :showResetButton="true"
      @reset="resetEvent"
    >
      <a-form-item slot="name_1" label="真实姓名" v-bind="searchItemLayout">
        <a-input v-model="queryParams.employeeName" :maxLength="20" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_2" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.mobile" :maxLength="11" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_3" label="企业" v-bind="searchItemLayout">
        <SelectEnterpriseModal
          :inputValue='queryParams.enterpriseId'
          :inputText='enterpriseName'
          @selectEnterpriseEvent='selectEnterprise'
        />
      </a-form-item>
      <a-form-item slot="name_4" label="认证结果" v-bind="searchItemLayout">
        <a-select v-model="queryParams.authStatus" style="width: 100%" allowClear placeholder="请选择">
          <a-select-option :value="1">认证中</a-select-option>
          <a-select-option :value="2">通过</a-select-option>
          <a-select-option :value="3">过期</a-select-option>
        </a-select>
      </a-form-item>
      <span slot="enterpriseName" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.enterpriseName }}
          </template>
          <div class="pro_title">
            {{ rowItem.record.enterpriseName }}
          </div>
        </a-tooltip>
      </span>
      <span slot="employeeName" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.employeeName }} ( {{ rowItem.record.mobile }} )
          </template>
          <div class="pro_title">
            {{ rowItem.record.employeeName }} ( {{ rowItem.record.mobile }} )
          </div>
        </a-tooltip>
      </span>
      <span slot="employeeNickname" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.employeeNickname }}
          </template>
          <div class="pro_title">
            {{ rowItem.record.employeeNickname }}
          </div>
        </a-tooltip>
      </span>
      <span slot="action" slot-scope="rowItem">
       <a @click="toDetailEvent(rowItem.record)">详情</a>
      </span>
    </search-page-view>

    <a-modal
      title='审核详情'
      okText="保存"
      :visible='modalVisible'
      width="480px"
      @cancel="cancelEvent"
      :footer="null"
    >
      <a-form-model
        :model="employeeDetail"
        ref="ruleForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="企业名称">{{ employeeDetail.enterpriseName }}</a-form-model-item>
        <a-form-model-item label="昵称">{{ employeeDetail.employeeNickname }}</a-form-model-item>
        <a-form-model-item label="手机号码">{{ employeeDetail.mobile }}</a-form-model-item>
        <a-form-model-item label="企业邮箱">{{ employeeDetail.enterpriseEmployeeEmail }}</a-form-model-item>
        <a-form-model-item label="真实姓名">{{ employeeDetail.employeeName }}</a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import WelfareMallMixins from '@/views/service/serviceProvider/welfareMall/mixins/WelfareMallMixins'
import SelectEnterpriseModal from '@/views/service/serviceProvider/welfareMall/SelectEnterpriseModal'

export default {
  name: 'WelfareMallAuthentication',
  mixins: [WelfareMallMixins],
  components: {
    SelectEnterpriseModal
  },
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      enterpriseName: '',
      modalVisible: false,
      employeeDetail: {}
    }
  },
  methods: {
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      params.mobile = params.mobile || undefined
      return this.getHttpServices().getServerApiService().post('welfare/getEmployeeAuthList', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '所属企业',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'enterpriseName' },
          width: '200px'
        },
        {
          title: '员工姓名',
          dataIndex: 'employeeName',
          scopedSlots: { customRender: 'employeeName' },
          width: '200px'
        },
        {
          title: '昵称',
          dataIndex: 'employeeNickname',
          scopedSlots: { customRender: 'employeeNickname' },
          width: '120px'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime'
        },
        {
          title: '认证时间',
          dataIndex: 'authTime'
        },
        {
          title: '认证方式',
          dataIndex: 'authTypeStr'
        },
        {
          title: '认证结果',
          dataIndex: 'authStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    resetEvent() {
      this.queryParams = {}
      this.enterpriseName = ''
      setTimeout(() => {
        this.$refs.pageList.refresh(true)
      }, 200)
    },
    selectEnterprise(info) { // 选择企业
      this.$set(this.queryParams, 'enterpriseId', info.value)
      this.enterpriseName = info.text
    },
    async toDetailEvent(record) {
      this.employeeDetail = await this.getEmployeeDetail(record)
      this.modalVisible = true
    },
    getEmployeeDetail(record) {
      return new Promise(resolve => {
        this.getHttpServices().getServerApiService().post('welfare/employeeDetail', {
          employeeId: record.employeeId,
          enterpriseId: record.enterpriseId,
          merchantId: this.merchantId,
          platformId: this.platformId
        }).then(res => {
          resolve(res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    cancelEvent() {
      this.modalVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.pro_title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>
